export default function ScatterPlotIcon() {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.83331 12.1667C4.21402 12.1667 5.33331 11.0474 5.33331 9.66669C5.33331 8.28598 4.21402 7.16669 2.83331 7.16669C1.4526 7.16669 0.333313 8.28598 0.333313 9.66669C0.333313 11.0474 1.4526 12.1667 2.83331 12.1667Z"
        fill="#323232"
      />
      <path
        d="M6.16663 5.5C7.54734 5.5 8.66663 4.38071 8.66663 3C8.66663 1.61929 7.54734 0.5 6.16663 0.5C4.78591 0.5 3.66663 1.61929 3.66663 3C3.66663 4.38071 4.78591 5.5 6.16663 5.5Z"
        fill="#323232"
      />
      <path
        d="M10.8333 15.1667C12.214 15.1667 13.3333 14.0474 13.3333 12.6667C13.3333 11.286 12.214 10.1667 10.8333 10.1667C9.4526 10.1667 8.33331 11.286 8.33331 12.6667C8.33331 14.0474 9.4526 15.1667 10.8333 15.1667Z"
        fill="#323232"
      />
    </svg>
  );
}
